const routes = [
  {
    path: '',
    component: () => import('@/views/provider/umesr/Wrapper.vue'),
    children: [
      {
        path: '/provider/umesr',
        name: 'UmesrSearch',
        component: () => import('@/views/provider/umesr/UmesrSearch.vue'),
      },
      {
        path: '/provider/umesr/create',
        name: 'UmesrCreate',
        component: () => import('@/views/provider/umesr/UmesrCRUD.vue'),
        props: true,
      },
      {
        path: '/provider/umesr/:id',
        name: 'UmesrDetails',
        component: () => import('@/views/provider/umesr/UmesrCRUD.vue'),
        props: true,
      },
    ],
  },
];

export default routes;
